export const FIAT_CURRENCIES = [
  'USD',
  'EUR',
  'BGN',
  'RUB',
];

export const CRYPTO_CURRENCIES = [
  'BTC',
  'ETH',
  'USDC',
  'USDT',
  'BNB',
  'SOL',
  'TRX',
  'MATIC',
  'POL',
  'LTC',
  'XRP',
  'DOGE',
  'TON',
  'DAI',
];

/** Fiat then crypto — stable order for autocomplete pickers. */
export const CURRENCY_OPTIONS = [
  ...FIAT_CURRENCIES,
  ...CRYPTO_CURRENCIES,
];

const CRYPTO_SET = new Set(CRYPTO_CURRENCIES);

/**
 * Whether a currency code is treated as crypto for display precision.
 *
 * @param {string|null|undefined} currency
 * @returns {boolean}
 */
export function isCryptoCurrency(currency) {
  if (!currency) return false;
  return CRYPTO_SET.has(String(currency).toUpperCase());
}
